import Vue from 'vue'
import { addClass, removeClass } from '@/common/utils/CommonFn.js'
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        addClass(el, 'is-disabled')
        setTimeout(() => {
          el.disabled = false
          removeClass(el, 'is-disabled')
        }, binding.value || 5000)
      }
    })
  }
});


// WEBPACK FOOTER //
// ./src/directive/prevent-reclick/directives.js